import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/init/init-db.component.ts' );

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatStepper, MatSnackBar, MatDialog } from '@angular/material';
import { Validators, FormControl } from '@angular/forms';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { flatMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BaseComponent } from '../commons/BaseComponent';
import { AppService } from '../commons/app.service';
import { TranslateService } from '@ngx-translate/core';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';

@Component({
  selector: 'admin-init-db',
  templateUrl: './init-db.component.html'
})
export class InitDBComponent extends BaseComponent implements OnInit {

  status:number
  message:string

  isDbInit:boolean = false

  checkingOther:boolean = false
  networkInterfaces:any
  selectedInterface:any

  passControl = new FormControl('', [Validators.required, Validators.maxLength(3)]);
  licenceControl = new FormControl('', [Validators.required]);
  addressControl = new FormControl('', [Validators.required]);
  netmaskControl = new FormControl('', [Validators.required]);
  gatewayControl = new FormControl('', [Validators.required]);

  constructor(public service:AppService, private route: ActivatedRoute, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog);
    DEBUG.log ( '/init/init-db.component.ts' );
  }

  ngOnInit() {

    console.log ( '%c /init/init-db.component.ts : onInit()', 'color:white;background-color:black;' );

    this.route.queryParams.subscribe(params => {
      this.status = params["status"]
      this.message = params["msg"]
    })

    this.checkInitDb()

  }

  onStepChanged(event:StepperSelectionEvent) {
    // When optional network check then query network details from the server
    if (event.selectedIndex == 2 && !this.networkInterfaces) {
      this.checkNetwork()
    }
  }

  checkInitDb() {

    DEBUG.log ( '/init/init-db.component.ts', 'checkInitDb()' );

    this.loading = true
    this.service.V.api("/vadmin/dba/initDB", "get")
        .subscribe(
          res => {
            this.isDbInit = res["db_url"] ? false : true
            this.loading = false
          }, err => {
            this.isDbInit = (err.status == 6000)
            //console.log("STATUS code: ",err.status)
            //console.log("STATUS this.isDbInit: ",this.isDbInit)
            this.loading = false
          }
        )
  }

  checkNetwork() {

    DEBUG.log ( '/init/init-db.component.ts', 'checkNetwork()' );
    
    this.selectedInterface = null // reset
    this.checkingOther = true

    let loginObs:Observable<any>
    if (this.service.V.localSession()) {
      // If we have a valid session we asume is an admin so use it
      loginObs = of(true)
    } else if (this.passControl.value) {
      // If no session but still have the password use it to login
      loginObs = this.service.V.loginWithUsernameObservable("admin",this.passControl.value)
    } else {
      // Otherwise ask for password and use it.
      loginObs = this.openDialog("INIT.ADMIN_PW",null,null,null,true).pipe(
        flatMap(pass => this.service.V.loginWithUsernameObservable("admin",pass))
      )
    }

    loginObs.pipe(
      flatMap(res => this.service.V.api("/admin/network", "get") )
    ).subscribe(
        res => {
          this.networkInterfaces = res
          // Try to selected the default interface to configure
          this.selectedInterface = res.find( ele => ( ele.name.toLowerCase().startsWith("e") && ele.ip4 ) )            
          this.checkingOther = false
        }, err => {

          this.checkingOther = false
        }
      )
  }

  setNetwork(netIf:any) {
    DEBUG.log ( '/init/init-db.component.ts', 'setNetwork()' );
    this.addressControl.setValue(netIf.ip4)
    this.netmaskControl.setValue("")
    this.gatewayControl.setValue("")
  }

  initDb(stepper: MatStepper, pass:string) {

    DEBUG.log ( '/init/init-db.component.ts', 'initDb()' );

    // Trigger vasat DB initi end-point passing the admin password
    let args = { password: pass}
    this.loading = true
    this.service.V.api("/vadmin/dba/initDB", "post", args)
        .subscribe(
          res => {
            this.loading = false
            this.isDbInit = true
            if (stepper) stepper.next()
            this.openSnackBarSuccess('GENERIC.SUCCESS')
          }, err => {
            this.loading = false
            this.openSnackBarError(err.message)
          }
        )

  }

  networkSetup(netIf:any) {

    DEBUG.log ( '/init/init-db.component.ts', 'networkSetup()' );

    let loginObs:Observable<any>

    let args = {
      name:netIf.name,
      address:this.addressControl.value,
      netmask:this.netmaskControl.value
    }

    if (this.gatewayControl.value) {
      args["gateway"] = this.gatewayControl.value
    }

    if (this.service.V.localSession()) {
      // If we have a valid session we asume is an admin so use it
      loginObs = of(true)
    } else if (this.passControl.value) {
      // If no session but still have the password use it to login
      loginObs = this.service.V.loginWithUsernameObservable("admin",this.passControl.value)
    } else {
      // Otherwise ask for password and use it.
      loginObs = this.openDialog("INIT.ADMIN_PW",null,null,null,true).pipe(
        flatMap(pass => this.service.V.loginWithUsernameObservable("admin",pass))
      )
    }
    loginObs.pipe(
      flatMap(res => this.service.V.api("/admin/network", "post", args))
    )
    .subscribe(
      res => {
        this.checkingOther = false
        this.openSnackBarSuccess('GENERIC.SUCCESS')
        // Reset to check changes applied
        //this.checkNetwork()
      }, err => {
        this.checkingOther = false
        this.openSnackBarError(err.message)
      }
    )
  
  }
}
